import { cloneElement, type ComponentProps, type ReactElement } from 'react'

import { SearchModal } from './SearchModal'
import { useOpenSearchModal } from './useOpenSearchModal'

type Props<Value, MatchData, Category extends string> = Omit<
  // Exclude didn't work with the generics
  ComponentProps<typeof SearchModal<Value, MatchData, Category>>,
  'isOpen' | 'onClose'
> & {
  trigger?: ReactElement<{ onClick: () => void }>
  isDisabled?: boolean
}

export const GlobalSearchModal = <Value, MatchData, Category extends string>({
  trigger,
  isDisabled = false,
  isShowingPreview,
  renderPreview,
  ...props
}: Props<Value, MatchData, Category>) => {
  const [isOpen, setIsOpen] = useOpenSearchModal(isDisabled)
  const hasPreview = isShowingPreview && renderPreview

  return (
    <>
      {trigger && cloneElement(trigger, { onClick: () => setIsOpen(true) })}

      {hasPreview ? (
        <SearchModal
          {...props}
          isShowingPreview
          renderPreview={renderPreview}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      ) : (
        <SearchModal
          {...props}
          isShowingPreview={false}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
